// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@awc/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { boxSharedStyle, xScreen } from "@awc/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

viewStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 447px) minmax(650px, 1fr);
        grid-template-rows: auto auto 1fr auto;
        grid-column-gap: 18px;
        grid-template-areas:
            "img right"
            "description right"
            "video right"
            "wide wide";

        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr);
            grid-template-areas:
                "right"
                "description"
                "video"
                "wide";
        }
        @media print {
            grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
            grid-template-areas:
                "img right"
                "description right"
                "video right"
                "wide wide";
        }
    `,
};

viewStyles.image = {
    css: css`
        grid-area: img;
        padding-bottom: 24px;
        ${xScreen("lte", "md")} {
            padding-bottom: 16px;
        }
    `,
};

viewStyles.imageTablet = {
    css: css`
        padding-bottom: 16px;
    `,
};

viewStyles.description = {
    css: css`
        grid-area: description;
        ${xScreen("lte", "md")} {
            padding-top: 48px;
        }
    `,
};

viewStyles.video = {
    css: css`
        grid-area: video;
        &:not(:has(> div:empty)) {
            padding-top: 24px;
        }
    `,
};

viewStyles.overstockSale = {
    css: css`
        ${xScreen("lte", "sm")} {
            .overstock {
                padding-top: 24px;
            }
        }
    `,
};
viewStyles.wideColumnWrapper = {
    css: css`
        grid-area: wide;
        ${GridItemStyle} {
            &:has(> div:empty) {
                display: none;
            }
        }
    `,
};

viewStyles.documents = {
    css: css`
        &:not(:has(> div:empty)) {
            padding-top: 24px;
        }
    `,
};

viewStyles.rightColumnWrapper = {
    css: css`
        grid-area: right;
        flex-direction: column;
        ${xScreen("gt", "sm")} {
            ${boxSharedStyle({ variant: "secondary" })}
        }
    `,
};

viewStyles.actionsWrapper = {
    css: css`
        display: flex;
        gap: 24px;
        > div {
            flex: 1 1 100%;
            :last-child {
                margin-left: auto;
                padding-top: 44px;
                flex: 0 0 317px;
            }
            :only-of-type {
                padding-top: 0;
            }
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            > div {
                :last-child {
                    flex: 1;
                    padding-top: 0;
                }
            }
        }
        @media print {
            flex-direction: column;
        }
    `,
};

viewStyles.title = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-bottom: 24px;
        ${xScreen("lte", "md")} {
            padding-bottom: 0;
        }
    `,
};
viewStyles.titleContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 0 22px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            padding-bottom: 16px;
        }
    `,
};

viewStyles.partNumbersWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${xScreen("lte", "md")} {
            padding-bottom: 16px;
        }
    `,
};
